import { useContext } from "react";
import GeneralContext from "../../context/GeneralContext";
import ButtonFunction from "./ButtonFunction";
import TextInputHorizontalTag from "./TextInputHorizontalTag";

function Modal() {

  const {
    modalTitle,
    modalText,
    modalContent,
    modalType,
    modalClass,
    modalFunction1,
    modalFunction2
  } = useContext(GeneralContext);

  
  const modal = document.getElementById("myModal");

  function closeModal () {
    modal.style.animation = 'disappear 0.5s';
    modal.addEventListener("animationend", function finAnimacion () {
      modal.removeEventListener("animationend", finAnimacion);
      modal.style.display = "none";
      modal.style.animation = 'appear 0.5s';
      if (modalType === 'request') {
        document.getElementById('commentText').value = '';
      }
      if (modalType === 'adjust') {
        document.getElementById('adjustAmount').value = 0;
        document.getElementById('adjustText').value = '';
      }
    })
  }

  const alertModal = () => {
    return (
      <>
        <p>{modalText}</p>
        <br />
        <ButtonFunction buttonClass={modalClass} buttonFunction={closeModal}>
          Aceptar
        </ButtonFunction>
      </>
    );
  }

  const requestModal = () => {
    return (
      <>
        {modalContent.map((item) => (
          <div key={item.id}>
            <label>{item.text}</label>
            <br/>
          </div>
        ))}
        <br />
        <label><strong>Razón de la decisión</strong></label>
        <br />
        <textarea id="commentText" cols="50" rows="5"></textarea>
        <br />
        <br />
        <div className="doubleColumnAuto">
          <div className="leftColumn">
            <ButtonFunction
            buttonClass={modalClass}
            buttonFunction={modalFunction1}>
              Aprobar
            </ButtonFunction>
          </div>
          <div className="rightColumn">
            <ButtonFunction
            buttonClass={modalClass}
            buttonFunction={modalFunction2}>
              Rechazar
            </ButtonFunction>
          </div>
        </div>
      </>
    )
  }

  const confirmModal = () => {
    return (
      <>
        <p>Esta acción puede ser irreversible, ¿seguro/a que desea continuar?</p>
        <br />
        <div className="doubleColumnAuto">
          <div className="leftColumn">
            <ButtonFunction buttonClass={modalClass} buttonFunction={modalFunction1}>Continuar</ButtonFunction>
          </div>
          <div className="rightColumn">
            <ButtonFunction buttonClass={modalClass} buttonFunction={closeModal}>Cancelar</ButtonFunction>
          </div>
        </div>
      </>
    )
  }

  const adjustModal = () => {
    return (
      <>
        <p>{modalText}</p>
        <p>{modalContent}</p>
        <TextInputHorizontalTag label="Cantidad del ajuste" type="number" inputClass='adminInput' id="adjustAmount"></TextInputHorizontalTag>
        <br />
        <label><strong>Razón del ajuste</strong></label>
        <br />
        <textarea id="adjustText" className="adjustText" cols="50" rows="2"></textarea>
        <br />
        <br />
        <div className="doubleColumnAuto">
          <div className="leftColumn">
            <ButtonFunction buttonClass={modalClass} buttonFunction={modalFunction1}>Modificar</ButtonFunction>
          </div>
          <div className="rightColumn">
            <ButtonFunction buttonClass={modalClass} buttonFunction={closeModal}>Cancelar</ButtonFunction>
          </div>
        </div>
      </>
    );
  }

  const modalByType = () => {
    switch (modalType) {
      case 'alert':
        return alertModal();
      case 'request':
        return requestModal();
      case 'confirm':
        return confirmModal();
      case 'adjust':
        return adjustModal();
      default:
        return null;
    }
  }

  return (
    <div id="myModal" className="modal">
      <div className="modal-content">
        <span className="close" onClick={closeModal}>&times;</span>
        <h1>{modalTitle}</h1>
        {modalByType()}
      </div>
    </div>
  )
}

export default Modal